import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

interface StepBlockProps {
  isCurrentStep: boolean;
}

export default styled.div<StepBlockProps>`
  display: flex;
  justify-content: flex-start;
  height: 6px;
  width: 60px;
  background-color: ${({ isCurrentStep }) =>
    isCurrentStep ? "#ffffff" : "rgba(224, 224, 224, 0.85)"};

  @media screen and (min-width: ${DESKTOP}px) {
    width: 6px;
    height: 49px;
  }
`;
